module.exports = __webpack_public_path__ + "static/media/Image_1.453aaabf.png";